module.exports = __webpack_public_path__ + "img/9788982739026.7f121900.jpg";